// components/clients/DeleteConfirmationDialog.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { Warning, Business } from '@mui/icons-material';

const DeleteConfirmationDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  client, 
  loading = false 
}) => {
  if (!client) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      disableEscapeKeyDown={loading}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="error" />
        Confirmar Eliminación
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Esta acción no se puede deshacer
        </Alert>
        
        <Typography variant="body1" gutterBottom>
          ¿Está seguro que desea eliminar el siguiente cliente?
        </Typography>
        
        <Box 
          sx={{ 
            mt: 2, 
            p: 2, 
            bgcolor: 'grey.100', 
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'grey.300'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Business color="primary" />
            <Typography variant="h6">
              {client.razon_social}
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            <strong>Horas:</strong> {client.horas} hs
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
            <strong>Monto Base:</strong> ${client.monto_base?.toLocaleString('es-AR', {
              minimumFractionDigits: 2
            })} (Sin IVA)
          </Typography>
          
          {client.id && (
            <Typography variant="body2" color="text.secondary">
              <strong>ID:</strong> {client.id}
            </Typography>
          )}
        </Box>
        
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          <strong>Advertencia:</strong> Se eliminarán todos los datos asociados a este cliente, 
          incluyendo históricos de documentos y cálculos.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button 
          onClick={onClose} 
          disabled={loading}
          color="inherit"
        >
          Cancelar
        </Button>
        <Button 
          onClick={() => onConfirm(client)}
          variant="contained" 
          color="error"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Eliminando...' : 'Eliminar Cliente'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;